<template lang='pug'>
//- 新增故事卡區塊
div(:class='$style[`cc-popbox-control-resume`]')
  .popbox-close
    button.popbox-close-btn(
      aria-label='關閉'
      tabindex='0'
      @click='handleClosePopBox')

  div(:class='$style[`cc-content-title`]')
    span(v-if='feature === `create`' :class='$style[`cc-banner-main-title`]')
      span.font-bold.font-doctor-theme(v-html='`建`')
      span.font-bold.font-normal-theme(v-html='`立`')
      span.font-bold.no-wrap(v-html='`故事卡`')
    span(v-else-if='feature === `update`' :class='$style[`cc-banner-main-title`]')
      span.font-bold.font-doctor-theme(v-html='`編`')
      span.font-bold.font-normal-theme(v-html='`輯`')
      span.font-bold.no-wrap(v-html='`故事卡`')
      div.font-regular(:class='$style[`cc-content-time-update`]') {{ `最後更新: ${resumeConfig.timeRecord}` }}

  ul(:class='$style[`cc-content-wrap`]')
    //- 癌症類型
    li(:class='$style[`cc-content-wrap-list`]')
      div(:class='$style[`cc-profile-list-title`]')!= '癌症類型'
      Select(
        title='選擇癌症類型'
        v-model='resumeConfig.typeValue'
        :class='[$style[`cc-input-selector`], $style[`cc-input-type`], $style[otherProfessionShow ? `cc-half-width` : ``]]'
        :key='`${nextTick}-1`'
        :placeholder='`選擇類型`'
        :defaultValue='resumeConfig.typeValue'
        :optionList='CANCER_TYPE'
        :errorValue='checkEmptyStatus.typeError'
        @sendSelectValue='setTypeSelectValue'
        @clearErrorMsg="(value) => {this.checkEmptyStatus.typeError = value}")

      Inputer(
        v-if='otherProfessionShow'
        v-model='resumeConfig.typeValue'
        title='填寫完整癌症全名'
        style='margin-left: 8px;'
        :class='[$style[`cc-input-selector`], $style[`cc-input-type`], $style[otherProfessionShow ? `cc-half-width` : ``]]'
        :resetButton='false'
        :key='`${nextTick}-1-2`'
        :placeholder='`某某癌`'
        :defaultValue='resumeConfig.typeValue'
        :errorValue='checkEmptyStatus.typeError'
        @clearErrorMsg="(value) => {this.checkEmptyStatus.typeError = value[0];}")


    //- 癌症分期
    li(:class='$style[`cc-content-wrap-list`]')
      div(:class='$style[`cc-profile-list-title`]')!= '患者性別'
      Select(
        title='選擇癌症分期'
        v-model='resumeConfig.genderValue'
        :class='[$style[`cc-input-selector`], $style[`cc-input-gender`]]'
        :key='`${nextTick}-2`'
        :placeholder='`性別`'
        :defaultValue='initUpdateModeDefaultValue(`gender`)'
        :optionList='[`先生`, `小姐`]'
        :errorValue='checkEmptyStatus.genderError'
        @sendSelectValue='setGenderSelectValue'
        @clearErrorMsg="(value) => {this.checkEmptyStatus.genderError = value}")

      div(:class='[$style[`cc-profile-list-title`], $style[`cc-profile-list-title-two`]]')!= '第幾期'
      Select(
        title='選擇癌症分期'
        v-model='resumeConfig.levelValue'
        :class='[$style[`cc-input-selector`], $style[`cc-input-level`]]'
        :key='`${nextTick}-3`'
        :placeholder='`期數`'
        :defaultValue='resumeConfig.levelValue'
        :optionList='[`ㄧ`, `二`, `三`, `四`]'
        :errorValue='checkEmptyStatus.levelError'
        @sendSelectValue='setLevelSelectValue'
        @clearErrorMsg="(value) => {this.checkEmptyStatus.levelError = value}")


    //- 確診年紀
    li(:class='$style[`cc-content-wrap-list`]')
      div(:class='$style[`cc-profile-list-title`]')!= '確診年紀'
      Inputer(
        title='請填寫確診年紀'
        v-model='resumeConfig.ageValue'
        :class='[$style[`cc-input-selector`], $style[`cc-input-age`]]'
        :resetButton='true'
        :key='`${nextTick}-4`'
        :placeholder='`數字 Ex: 18`'
        :defaultValue='resumeConfig.ageValue'
        :errorRegex='checkEmptyStatus.ageRegexError'
        :errorRegexInfo='checkEmptyStatus.ageRegexErrorLog'
        :errorValue='checkEmptyStatus.ageError'
        @clearErrorMsg="(value) => {this.checkEmptyStatus.ageError = value[0]; this.checkEmptyStatus.ageRegexErrorLog = '';}")


    //- 主治醫師姓名
    li(:class='$style[`cc-content-wrap-list`]')
      div(:class='$style[`cc-profile-list-title`]')!= '主治醫師'
      Inputer(
        title='請填寫醫師全名'
        v-model='resumeConfig.myDoctorValue'
        :class='[$style[`cc-input-selector`], $style[`cc-input-myDoctor`]]'
        :resetButton='true'
        :key='`${nextTick}-5`'
        :placeholder='`目前主治醫師全名`'
        :defaultValue='resumeConfig.myDoctorValue'
        :errorValue='checkEmptyStatus.myDoctorError'
        @clearErrorMsg="(value) => {this.checkEmptyStatus.myDoctorError = value[0];}")


    //- 填寫者身份
    li(:class='$style[`cc-content-wrap-list`]')
      div(:class='[$style[`cc-profile-list-title`], $style[`cc-profile-list-title-five`]]')!= '填寫者身份'
      Select(
        title='請選擇'
        v-model='resumeConfig.identityValue'
        :class='[$style[`cc-input-selector`], $style[`cc-input-identity`]]'
        :key='`${nextTick}-6`'
        :placeholder='`請選擇`'
        :defaultValue='initUpdateModeDefaultValue(`identity`)'
        :optionList='[`我是本人`, `患者親友`]'
        :errorValue='checkEmptyStatus.identityError'
        @sendSelectValue='setIdentitySelectValue'
        @clearErrorMsg="(value) => {this.checkEmptyStatus.identityError = value}")


    //- 家族是否有病史
    li(:class='$style[`cc-content-wrap-list`]')
      div(:class='[$style[`cc-profile-list-title`], $style[`cc-profile-list-title-seven`]]')!= '家族是否有病史'
      Select(
        title='請選擇'
        v-model='resumeConfig.familyValue'
        :class='[$style[`cc-input-selector`], $style[`cc-input-family`]]'
        :key='`${nextTick}-7`'
        :placeholder='`請選擇`'
        :defaultValue='initUpdateModeDefaultValue(`family`)'
        :optionList='[`有`, `沒有`]'
        :errorValue='checkEmptyStatus.familyError'
        @sendSelectValue='setFamilySelectValue'
        @clearErrorMsg="(value) => {this.checkEmptyStatus.familyError = value}")

  div(
    v-if='feature === `create`'
    title='確認新增'
    :class='[$style[`cc-content-new-send`], $style[!this.resumeConfig.typeValue && !this.resumeConfig.levelValue && !this.resumeConfig.familyValue && !this.resumeConfig.ageValue && !this.resumeConfig.genderValue && !this.resumeConfig.identityValue && !this.resumeConfig.myDoctorValue ? `cc-content-disabled` : ``]]'
    @click='handleCheckProgressBeforeCreate')
    IconLoading(v-if='showLoading' :size='18' :color='`#fff`')
    span {{ showLoading ? `` : `確認新增`}}

  div(
    v-else-if='feature === `update`'
    title='更新完成'
    :class='$style[`cc-content-new-send`]'
    @click='handleCheckProgressBeforeCreate')
    IconLoading(v-if='showLoading' :size='18' :color='`#fff`')
    span {{ showLoading ? `` : `更新完成`}}


</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import { debounce } from 'debounce';

import Inputer from '../common/Input';
import Select from '../common/Select';
import IconLoading from '../../icon/Loading';

import {
  postUserNewResume,
  putResumeStatus,
  getMemberResume,
} from '../../../js/restapi';

export default {
  components: {
    Inputer,
    Select,
    IconLoading,
  },

  props: {
    feature: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      showLoading: false,
      loginFailed: false,
      otherProfessionShow: false,
      yearList: [],

      nextTick: 0,

      resumeConfig: {
        typeValue: '',
        levelValue: '',
        familyValue: '',
        ageValue: '',
        genderValue: '',
        identityValue: '',
        myDoctorValue: '',
        timeRecord: '',
      },

      checkEmptyStatus: {
        typeError: false,
        levelError: false,
        familyError: false,

        ageError: false,
        ageRegexError: false,
        ageRegexErrorLog: '',

        genderError: false,
        identityError: false,
        myDoctorValue: false,
      },
      verifyAllPass: true,
      showErrorMsg: false,
    };
  },

  created() {
    this.showErrorMsg = this.$options.data().showErrorMsg;
    this.loginFailed = this.$options.data().loginFailed;
    this.initSelectYearList(40);

    if (this.feature === 'update') {
      this.handleInitResumeData();
    } else if (this.feature === 'create') {
      this.resumeConfig = this.$options.data().resumeConfig;
    }
  },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
      changeUpdateKey: 'global/FORCE_UPDATE_KEY',
    }),

    handleClosePopBox() {
      this.changePopBoxStatus({
        active: false,
        include: '',
      });
    },

    handleInitResumeData() {
      const PASS_DATA = {
        pk: `${this.loginDjangoId}`,
        card: '1',
        auth_id: `${this.loginDjangoId}`,
      };

      getMemberResume('', PASS_DATA)
        .then((response) => {
          const RES_DATA = response.data;
          // 強迫 Child 更新
          this.nextTick += 1;

          this.resumeConfig = {
            typeValue: RES_DATA.status.cancertype,
            levelValue: RES_DATA.status.level,
            familyValue: RES_DATA.status.family,
            ageValue: RES_DATA.status.age,
            genderValue: RES_DATA.status.gender,
            identityValue: RES_DATA.status.identity,
            myDoctorValue: RES_DATA.status.myDoctor,
            timeRecord: RES_DATA.status.time_record,
          };
        })
        .catch((/* error */) => {});
    },

    initSelectYearList(maxLength) {
      const yearNow = new Date().getFullYear();
      let n = 0;
      while (n < maxLength) {
        this.yearList.push(yearNow - n);
        n += 1;
      }
    },

    initUpdateModeDefaultValue(checkValue) {
      if (this.feature === 'create') { return; }

      let returnValue = '';
      switch (checkValue) {
        case 'identity':
          if (this.resumeConfig.identityValue === '0') {
            returnValue = '我是本人';
          } else if (this.resumeConfig.identityValue === '1') {
            returnValue = '患者親友';
          }
          break;

        case 'gender':
          if (this.resumeConfig.genderValue === '0') {
            returnValue = '先生';
          } else if (this.resumeConfig.genderValue === '1') {
            returnValue = '小姐';
          }
          break;

        case 'family':
          if (this.resumeConfig.familyValue === 'yes') {
            returnValue = '有';
          } else if (this.resumeConfig.familyValue === 'no') {
            returnValue = '沒有';
          }
          break;
        default:
          break;
      }
      // eslint-disable-next-line consistent-return
      return returnValue;
    },

    setTypeSelectValue(value) {
      // this.resumeConfig.typeValue = value;
      if (value === '填寫其他') {
        this.otherProfessionShow = true;
        this.resumeConfig.typeValue = '';
      } else {
        this.otherProfessionShow = false;
        this.resumeConfig.typeValue = value;
      }
    },

    setLevelSelectValue(value) {
      this.resumeConfig.levelValue = value;
    },

    setGenderSelectValue(value) {
      // eslint-disable-next-line no-unused-expressions
      value === '先生' ? this.resumeConfig.genderValue = '0' : this.resumeConfig.genderValue = '1';
    },

    setIdentitySelectValue(value) {
      // eslint-disable-next-line no-unused-expressions
      value === '我是本人' ? this.resumeConfig.identityValue = '0' : this.resumeConfig.identityValue = '1';
    },

    setFamilySelectValue(value) {
      // eslint-disable-next-line no-unused-expressions
      value === '有' ? this.resumeConfig.familyValue = 'yes' : this.resumeConfig.familyValue = 'no';
    },

    setAgeSelectValue(value) {
      this.resumeConfig.ageValue = value;
    },

    handleResumeConfigCheck() {
      this.verifyAllPass = this.$options.data().verifyAllPass;
      const ageRegex = new RegExp(/^\d{1,2}$/);

      if (!this.resumeConfig.typeValue) {
        this.checkEmptyStatus.typeError = true;
        this.verifyAllPass = false;
      }

      if (this.resumeConfig.ageValue) {
        if (!this.resumeConfig.ageValue.match(ageRegex)) {
          this.checkEmptyStatus.ageRegexError = true;
          this.checkEmptyStatus.ageError = true;
          this.checkEmptyStatus.ageRegexErrorLog = '請輸入2位數內阿拉伯數字';
          this.verifyAllPass = false;
        }
      } else {
        this.checkEmptyStatus.ageError = true;
        this.verifyAllPass = false;
      }

      if (!this.resumeConfig.genderValue) {
        this.checkEmptyStatus.genderError = true;
        this.verifyAllPass = false;
      }

      if (!this.resumeConfig.levelValue) {
        this.checkEmptyStatus.levelError = true;
        this.verifyAllPass = false;
      }

      if (!this.resumeConfig.identityValue) {
        this.checkEmptyStatus.identityError = true;
        this.verifyAllPass = false;
      }

      if (!this.resumeConfig.familyValue) {
        this.checkEmptyStatus.familyError = true;
        this.verifyAllPass = false;
      }
    },

    handleConnectDjangoWithApi() {
      // IF Verify On Error, Return
      if (!this.verifyAllPass) { return; }
      this.showLoading = true;

      if (this.feature === 'create') {
        this.createDebounceEvent();
      } else if (this.feature === 'update') {
        this.updateDebounceEvent();
      }
    },

    // eslint-disable-next-line func-names
    createDebounceEvent: debounce(function (/* e */) {
      // const jwtAccess = JSON.parse(this.authJwtToken).a;

      const POST_PASS_DATA = {
        pk: `${this.loginDjangoId}`,
        card: '1',
      };

      const UPDATE_STATUS_DATA = {
        pk: `${this.loginDjangoId}`,
        card: '1',
        cancertype: this.resumeConfig.typeValue,
        level: this.resumeConfig.levelValue,
        family: this.resumeConfig.familyValue,
        age: this.resumeConfig.ageValue,
        gender: this.resumeConfig.genderValue,
        identity: this.resumeConfig.identityValue,
        myDoctor: this.resumeConfig.myDoctorValue,
      };

      // 建立新的故事卡
      postUserNewResume('', POST_PASS_DATA, {
        headers: {
          'content-Type': 'application/json',
          // Authorization: `Bearer ${jwtAccess}`,
        },
      })
        .then((/* response */) => {
          // 更新故事卡狀態
          putResumeStatus('', UPDATE_STATUS_DATA, {
            headers: {
              'content-Type': 'application/json',
              // Authorization: `Bearer ${jwtAccess}`,
            },
          })
            .then((/* response */) => {
              this.showLoading = false;
              this.handleUserAddHp(this.loginDjangoId, '+500');
              // this.handleUserAddScore(this.loginDjangoId, 'both', { hp: '+300', point: '+30' });
              this.changePopBoxStatus({
                active: true,
                include: 'createConfirm',
              });
              setTimeout(() => {
                // 關閉 POPBOX
                this.handleClosePopBox();

                if (this.$router.currentRoute.name === 'profile-resume') {
                  this.changeUpdateKey();
                } else {
                  this.$router.push({
                    name: 'profile-resume',
                    params: {
                      type: 'normal',
                      id: this.loginDjangoId,
                    },
                  }).catch(() => true);
                }
              }, this.POP_DURATION);

            })
            .catch((error) => {
              this.showLoading = false;
              if (error.response.status === 401) {
                this.changePopBoxStatus({
                  active: true,
                  include: 'relogin',
                });
              }
            });
        })
        .catch((/* error */) => {
          this.showLoading = false;
        });
    }, 300),

    // eslint-disable-next-line func-names
    updateDebounceEvent: debounce(function (/* e */) {
      // const jwtAccess = JSON.parse(this.authJwtToken).a;

      const UPDATE_STATUS_DATA = {
        pk: `${this.loginDjangoId}`,
        card: '1',
        cancertype: this.resumeConfig.typeValue,
        level: this.resumeConfig.levelValue,
        family: this.resumeConfig.familyValue,
        age: this.resumeConfig.ageValue,
        gender: this.resumeConfig.genderValue,
        identity: this.resumeConfig.identityValue,
        myDoctor: this.resumeConfig.myDoctorValue,
      };

      // 更新故事卡狀態
      putResumeStatus('', UPDATE_STATUS_DATA, {
        headers: {
          'content-Type': 'application/json',
          // Authorization: `Bearer ${jwtAccess}`,
        },
      })
        .then((/* response */) => {
          this.showLoading = false;
          this.changePopBoxStatus({
            active: true,
            include: 'updateConfirm',
          });
          setTimeout(() => {
            // 關閉 POPBOX
            this.handleClosePopBox();
            this.changeUpdateKey();
          }, this.POP_DURATION);
        })
        .catch((error) => {
          this.showLoading = false;
          if (error.response.status === 401) {
            this.changePopBoxStatus({
              active: true,
              include: 'relogin',
            });
          }
        });
    }, 300),

    async handleCheckProgressBeforeCreate() {
      await this.handleResumeConfigCheck();
      await this.handleConnectDjangoWithApi();
    },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      // loginStatus: 'user/exportLoginStatus',
      // loginProfile: 'user/exportUserProfile',
      loginDjangoId: 'user/exportUserDjangoId',
      authJwtToken: 'user/exportUserJwtToken',
    }),
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popControlResume.scss';
</style>
